import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["phases", "currentPhaseKey", "progress", "hideProgressBar", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.funnel-progress */
import { Fragment } from 'react'; // This is a bit of a hack to ensure that the progress bar starts after the 'step number'

import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var STARTING_PROGRESS = 0.1;

var PhaseIcon = function PhaseIcon(_ref) {
  var variant = _ref.variant,
      step = _ref.step;
  return _jsxs("div", {
    sx: {
      variant: "elements.funnel-progress.base.phaseIcon.variants.".concat(variant)
    },
    children: [variant === 'complete' ? _jsx("div", {
      sx: {
        variant: 'elements.funnel-progress.base.phaseCompleteIcon.base'
      },
      children: step
    }) : null, _jsx(Otherwise, {
      children: step
    })]
  });
};

var Percentage = function Percentage(_ref2) {
  var progress = _ref2.progress;
  var percentage = "".concat(Math.round((progress + 0.1) * 100), "%");
  return _jsx("div", {
    sx: {
      variant: 'elements.funnel-progress.variants.percentage.displayPercentage'
    },
    children: percentage
  });
};

var FunnelPhase = function FunnelPhase(_ref3) {
  var step = _ref3.step,
      open = _ref3.open,
      complete = _ref3.complete,
      title = _ref3.phase.title;
  return _jsx("div", {
    sx: {
      variant: !open ? 'elements.funnel-progress.base.phase.base' : 'elements.funnel-progress.base.phase.variants.open'
    },
    children: _jsxs("div", {
      sx: {
        variant: 'elements.funnel-progress.base.phaseLabel.base'
      },
      children: [_jsx("div", {
        sx: {
          variant: 'elements.funnel-progress.base.phaseLabelPart.base'
        },
        children: _jsx(PhaseIcon, {
          step: step,
          variant: open ? 'open' : complete ? 'complete' : 'incomplete'
        })
      }), open && _jsx("div", {
        sx: {
          variant: 'elements.funnel-progress.base.phaseLabelPart.base'
        },
        children: title
      })]
    })
  });
};

var FunnelProgress = function FunnelProgress(_ref4) {
  var phases = _ref4.phases,
      currentPhaseKey = _ref4.currentPhaseKey,
      progress = _ref4.progress,
      hideProgressBar = _ref4.hideProgressBar,
      variant = _ref4.variant,
      rest = _objectWithoutProperties(_ref4, _excluded);

  var currentPhaseIndex = phases.findIndex(function (_ref5) {
    var key = _ref5.key;
    return key === currentPhaseKey;
  });
  var percentageVariant = variant === 'percentage';

  var variantPath = function variantPath() {
    var additionalPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return "elements.funnel-progress.".concat(variant ? "variants.".concat(variant) : 'base').concat(additionalPath);
  };

  var minWidth = percentageVariant ? '10%' : '0%';
  return _jsxs(Fragment, {
    children: [_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
      sx: {
        variant: variantPath()
      },
      children: [!percentageVariant && phases.map(function (phase, ind) {
        return _jsx(FunnelPhase, {
          step: ind + 1,
          open: ind === currentPhaseIndex,
          complete: ind < currentPhaseIndex,
          progress: progress,
          phase: phase
        }, ind);
      }), percentageVariant && _jsx(Percentage, {
        progress: progress
      })]
    })), !hideProgressBar && _jsx("div", {
      sx: {
        variant: variantPath('.progess.back'),
        height: '4px',
        width: '100%',
        position: 'relative',
        backgroundColor: 'progress-bg',
        marginTop: '13px'
      },
      children: _jsx("div", {
        sx: {
          variant: progress !== 0 ? variantPath('.progress.base') : variantPath('.progress.variants.start')
        },
        style: {
          width: progress !== 0 ? "".concat(STARTING_PROGRESS * 100 + progress * (1 - STARTING_PROGRESS) * 100, "%") : minWidth
        }
      })
    })]
  });
};

export default FunnelProgress;
//# sourceMappingURL=funnel-progress.js.map